<script>

export default {
  name: 'app',
  components: {
  }
}
</script>


<style src="../node_modules/swiper/dist/css/swiper.min.css"/>
<style src="../src/fonts/arial.css"/>


<style>
body,html{
  margin:0;
}

*{
  box-sizing: border-box;
}

#app {
  margin:0;
}
</style>



// WEBPACK FOOTER //
// App.vue?390b77b4